"use client";

import { useState } from "react";
import Modal from "..";
import { Button } from "@/components/ui/button";
import { AlertBadge } from "@/components/icons";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Controller, useForm } from "react-hook-form";
import { useSubscribeMutation } from "@/features/newsletter/newsLetterApi";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

const NotifyMe = ({ origin }: { origin?: string }) => {
  const [open, setOpen] = useState(false);
  const [subscribe, { isLoading }] = useSubscribeMutation();

  const { handleSubmit, control, setError } = useForm<{
    email: string;
  }>({
    defaultValues: {
      email: "",
    },
    mode: "onChange",
  });

  const onSubmit = async (data: { email: string }) => {
    const payload = {
      email: data.email,
    };
    try {
      const resposne = await subscribe(payload).unwrap();
      toast.success(resposne.message);
      setOpen(false);
    } catch (error: any) {
      setError("email", {
        type: "manual",
        message:
          error?.data?.message ||
          "Something went wrong. Please try again later.",
      });
    }
  };
  return (
    <div>
      <Button
        className="w-full rounded-full lg:w-fit"
        size="xl"
        onClick={() => setOpen(true)}
      >
        Get Notified{" "}
        <span
          className={cn("inline lg:hidden xl:inline", {
            "hidden sm:inline": origin === "home",
          })}
        >
          For Upcoming Sessions
        </span>
        <AlertBadge className="ml-2 size-6 text-white" />
      </Button>
      <Modal open={open} onOpenChange={() => setOpen(false)}>
        <form className="flex flex-col gap-6" onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-2">
            <h3 className="text-primary mb-2 text-xl font-semibold lg:text-4xl">
              Stay Informed About Upcoming Sessions!
            </h3>
            <p className="text-sm font-medium text-slate-700 lg:text-xl">
              Enter your email address for notifications about our next
              available sessions, including course dates, topics, and exclusive
              early access.
            </p>
          </div>
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="email">
              Email <span className="text-red-500">*</span>
            </Label>
            <Controller
              control={control}
              name="email"
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email address",
                },
              }}
              render={({
                field: { onChange, value, onBlur },
                fieldState: { error },
              }) => (
                <Input
                  type="text"
                  classes={{ input: "bg-white" }}
                  placeholder="Enter email address"
                  onChange={onChange}
                  onBlur={onBlur}
                  value={value}
                  errorText={error?.message}
                />
              )}
            />
          </div>
          <div className="mt-4 flex w-full justify-between gap-4">
            <Button
              type="button"
              size="xl"
              variant={"outline"}
              className="w-1/2 rounded-full"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              size="xl"
              className="w-1/2 rounded-full"
              disabled={isLoading}
            >
              Notify Me
            </Button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default NotifyMe;
